import React, { useEffect, useState } from 'react';
import HeaderRec from '../../header/headerRec';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../../commun/Pagination';
import GenericTable from '../../commun/GenericTable';
import StatusTabs from '../../commun/StatusTabs';
import { recruteurCandidatureStatus, recruteurCandidatureStatusCandidatureStatus } from '../../commun/constants/options';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';
import '../../Entreprise/CandidaturesEntreprise/CandidaturesEntreprise.css';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { showDeleteConfirmation } from '../../commun/deletemsg';
import axios from 'axios';

const Candidature = () => {
  const navigate = useNavigate();
  const recruteurName = localStorage.getItem('recruteurName');
  const authToken = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [allCandidatures, setAllCandidatures] = useState([]);
  const [filteredStatus, setFilteredStatus] = useState(null);
  const [grouped, setGrouped] = useState({});
  const [page, setPage] = useState(1);
  const [displayMode, setDisplayMode] = useState('table'); 

  const itemsPerPage = 8;

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) navigate('/');
  }, [navigate]);

  useEffect(() => {
    const fetchCandidatures = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/candidatures/recruteur/candidatures?userId=${userId}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await res.json();
        data.sort((a, b) => new Date(b.dateEnvoi) - new Date(a.dateEnvoi));
        setAllCandidatures(data);
      } catch (err) {
        console.error('Erreur de chargement des candidatures:', err);
      }
    };

    fetchCandidatures();
  }, [authToken]);

  useEffect(() => {
    const group = {};
    allCandidatures.forEach((c) => {
      const stat = c.statut || 'Inconnu';
      if (!group[stat]) group[stat] = [];
      group[stat].push(c);
    });
    setGrouped(group);
  }, [allCandidatures]);

  useEffect(() => {
    setPage(1);
  }, [filteredStatus]);

  const displayedCandidatures = filteredStatus
    ? grouped[filteredStatus] || []
    : allCandidatures;

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = page * itemsPerPage;
  const paginatedCandidatures = displayedCandidatures.slice(startIndex, endIndex);

  const columns = [
    { key: 'reference', label: 'Talent' },
    { key: 'score', label: 'Score' },
    { key: 'dateEnvoi', label: 'Date de candidature' },
    { key: 'mission', label: 'Mission' },
    { key: 'entreprise', label: 'Entreprise' },
    { key: 'statut', label: 'Statut' },
  ];

  const handleDelete = async (id) => {  
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          const res = await fetch(`${API_BASE}/api/candidatures/${id}`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${authToken}` },
          });
  
          if (res.ok) {
            setAllCandidatures(prev => prev.filter(c => c._id !== id));
          } else {
            alert("Erreur lors de la suppression.");
          }
        } catch (err) {
          console.error("Erreur serveur :", err);
          alert("Erreur serveur. Veuillez réessayer.");
        }
      }
    });
  };
  

  const renderActions = (row) => {
    const statut = typeof row.rawStatut === 'string' ? row.rawStatut.toLowerCase() : '';
    const isDraft = statut === 'brouillon';

    return (
      <>
      <button
        className="btn-detail"
        onClick={() => {
          if (isDraft) {
            navigate(`/recruteur/travailler-mission/${row.missionId}?t=${row.candidatId}`);
          } else {
            navigate(`/Recruteur/DetailsCandidature/${row._id}`);
          }
        }}
      >
        {isDraft ? 'Reprendre' : 'Détails'}
        </button>

        {isDraft && (
        <IconButton onClick={() =>  handleDelete(row._id)} color="error">
        <DeleteIcon />
        </IconButton>
        )}
      </>
    );
  };

const tableData = displayedCandidatures.map((c) => {
    const rawStatus = c.statut || 'Inconnu';
    const matchedStatus = recruteurCandidatureStatus.find((s) => s.value.toLowerCase() === rawStatus.toLowerCase());
    return {
      reference: (
        <Link to={`/Recruteur/talent-detail/${c.candidatId._id}`}>
          {`${c.candidatId.prenomCandidat || ''} ${c.candidatId.nomCandidat || ''}`.trim() || 'N/A'}
        </Link>
      ),
      score: c.similarity != null ? `${(c.similarity * 100).toFixed(1)}%`: 'N/A',
      mission: c.missionId?.nomMission || 'N/A',
      entreprise: c.entreprise,
      dateEnvoi: c.dateEnvoi
        ? new Date(c.dateEnvoi).toLocaleDateString('fr-FR')
        : 'N/A',
      statut: (
        <span className="status-cell" style={matchedStatus?.style}>
          {rawStatus === 'A traiter'
            ? 'Candidature envoyée'
            : matchedStatus?.label || rawStatus}
        </span>
      ),
      _id: c._id,
      rawStatut: rawStatus,
      candidatId: c.candidatId?._id,
      missionId: c.missionId?._id,
    };
  });

  return (
    <div className="recruteur-page">
      <HeaderRec
        recruteurName={recruteurName}
        authToken={authToken}
        userId={userId}
      />
      <main className="pageContainer">
        <h2 className="pageTitle">Mes candidatures</h2>

        <StatusTabs
          statuses={grouped}
          activeStatus={filteredStatus}
          onStatusChange={setFilteredStatus}
          statusStylesSource={recruteurCandidatureStatus}
          userRole="recruteur"
        />

        <div className="tableWrapper">
       <GenericTable
        columns={columns}
        data={tableData}
        renderActions={renderActions}
        totalItems={displayedCandidatures.length}
        showCheckboxes={false}
        itemsPerPage={itemsPerPage}
        currentPage={page}
        setPage={setPage}
        displayMode={displayMode}
        setDisplayMode={setDisplayMode}
        useReferenceAsCardTitle={true}
      />


          {displayMode === 'table' && displayedCandidatures.length > 0 && (
        <Pagination
          page={page}
          setPage={setPage}
          totalItems={displayedCandidatures.length}
          itemsPerPage={itemsPerPage}
        />
      )}


          <Chatbox userRole="recruteur" />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Candidature;
